export const passengerModel = {
    havePrivilege: false,
    discountPCT: null,
    type: "adult",
    priceException: null,
    email: "",
    insurance: false, // todo gde se koristi
    name: "",
    phone: "",
    sms: "", // todo gde se koristi
    surname: "",
    clientIdentity: "",
    cardNumber: "",
    seat: null,
    returnSeat: null,
    vehicleId: null,
    returnVehicleId: null,
    ticketId: null,
    returnTicketId: null,
    haveOppositeDirection: false
}
